import { render, staticRenderFns } from "./ListPropertiesPaymentPage.vue?vue&type=template&id=5424d462&scoped=true"
import script from "./ListPropertiesPaymentPage.vue?vue&type=script&lang=js"
export * from "./ListPropertiesPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./ListPropertiesPaymentPage.vue?vue&type=style&index=0&id=5424d462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424d462",
  null
  
)

export default component.exports